import React, { Component } from 'react';
import adCreditsDisclaimerText from 'app/common/react/components/partner/BusinessAccount/adCreditsDisclaimerText';
import adCreditsDisclaimerTextSimplified from 'app/common/react/components/partner/BusinessAccount/adCreditsDisclaimerTextSimplified';
import AlternativesSeparator from 'app/common/react/components/growth/unauth/signup/AlternativesSeparator/AlternativesSeparator';
import audienceBackground from 'app/common/images/inspired-desktop/bg_business_account_convert.jpg';
import audienceHalfImage from 'app/common/images/inspired-desktop/bg_audience_half.png';
import BusinessAccountCreateWarningModal from 'app/common/react/components/partner/BusinessAccount/BusinessAccountCreate/BusinessAccountCreateWarningModal';
import BusinessAcquisitionTracking from 'app/packages/business-tracking';
import BusinessAcquisitionTrackingConstants from 'app/packages/business-tracking/constants';
import changeWindowLocation from 'app/common/lib/util/changeWindowLocation';
import CONST from 'app/common/lib/Const';
import contextLogger from 'app/common/lib/ContextLogger';
import debounce from 'lodash/debounce';
import FacebookConnectButton from 'app/common/react/components/growth/unauth/signup/FacebookConnectButton/FacebookConnectButton';
import i18n from 'app/common/lib/i18n';
import LoadingMask from 'app/common/react/components/growth/unauth/signup/LoadingMask/LoadingMask';
import Logging from 'app/common/lib/Logging';
import logStats from 'app/common/lib/logStats';
import PropTypes from 'prop-types';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import TextInputField from 'app/common/react/components/growth/unauth/signup/TextInputField/TextInputField';
import urlUtil from 'app/common/lib/urlUtil';
import UserRegistration from 'app/common/react/components/growth/unauth/signup/UserRegistration';
import UserRegistrationDeprecated from 'app/common/lib/UserRegistration';
import withContextLog from 'app/common/lib/react/deprecated/withContextLog'; // eslint-disable-line pinterest/no-deprecated-imports
import { appendQuery } from 'app/packages/url';
import { compose } from 'redux';
import { Experiment } from 'app/common/react/components/experiments';
import { inAdCreditsCampaign } from 'app/common/lib/BusinessPaidCampaignUtils';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { logBusinessEvent } from 'app/common/lib/BusinessLoggingUtils';
import { showError } from 'app/common/react/components/growth/unauth/lib/ErrorUtils';
import { SingleTreatmentExp } from 'app/common/lib/experiment';
import { withRouter } from 'react-router';
import withUnauthSeoExperiments, {
  ExperimentsPropType,
} from 'app/common/lib/react/withUnauthSeoExperiments';
import {
  ContainsOnlyAscii,
  Email,
  getErrors,
  NewPassword,
  Required,
} from 'app/common/lib/react/validator';
import {
  FIELD_VALIDATION_TIMEOUT,
  prefixRegisterAction,
  toUnderscoredObject,
} from 'app/common/react/components/partner/BusinessAccount/businessAccountUtils';
import {
  withRequestContext,
  RequestContextPropType,
} from 'app/common/react/components/RequestContext';
import { Button, Box, Heading, Text, Icon, Link, Image, Mask, Container, Column } from 'gestalt';

const privacyUrl = CONST.GEN.templateConst.settings.ABOUT_PRIVACY_URL;
const termsOfServiceUrl = CONST.GEN.templateConst.settings.PARTNER_SITE_TOS_URL;
const registerAction = prefixRegisterAction('create_business_account_singlestep.');
const registerFocus = (field) => registerAction(`${field}FieldFocused`);

export class BusinessAccountCreate extends Component {
  static propTypes = {
    cookies: PropTypes.shape(),
    country: PropTypes.string,
    contextLog: PropTypes.func.isRequired,
    isAuth: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    options: PropTypes.shape({
      email: PropTypes.string,
    }),
    seoUnauthExperiments: ExperimentsPropType,
    requestContext: RequestContextPropType,
    unifiedSignup: PropTypes.bool,
    router: PropTypes.shape({
      location: PropTypes.string,
    }),
  };

  static childContextTypes = {
    cookies: PropTypes.shape({}),
    country: PropTypes.string,
    userAgent: PropTypes.shape({
      isMobile: PropTypes.bool,
    }),
  };

  constructor(props, context) {
    super(props);
    this.state = {
      businessName: '',
      businessImages: {
        background: audienceBackground,
        halfImage: audienceHalfImage,
      },
      clickedSubmit: false,
      email: '',
      password: '',
      errors: {
        businessName: [],
        email: [],
        password: [],
      },
      showWarningModal: props.isAuth,
      isSubmittingForm: false,
      isRerequest: false,
    };

    this.validators = {
      email: [
        Required({
          message: i18n._(
            "You missed a spot! Don't forget to add your email.",
            'Prompt user to input email on error',
          ),
        }),
        Email({
          message: i18n._(
            "Hmm... that doesn't look like an email address.",
            'Prompt user to input a valid email',
          ),
        }),
      ],
      password: [
        Required({
          message: i18n._(
            'Your password is too short! You need 6+ characters.',
            'Prompt user to input password on error',
          ),
        }),
        ContainsOnlyAscii({
          message: i18n._(
            'Oh @*&#! No zany characters allowed.',
            'Only ASCII characters are allowed for password',
          ),
        }),
        NewPassword({
          shortPassStr: i18n._(
            'Your password is too short! You need 6+ characters.',
            'Password must be at least 6 characters',
          ),
          samePasswordStr: i18n._(
            'Please make your username and password different.',
            'Password and username cannot be the same, user must choose a new password',
          ),
          blackPassStr: i18n._('Please make a stronger password.', 'Password is too simple'),
        }),
      ],
      businessName: [
        Required({
          message: i18n._(
            "You missed a spot! Don't forget to add your business name.",
            'Prompt user to input business name on error',
          ),
        }),
      ],
    };

    this.title = i18n._(
      "Welcome to Pinterest, the world's catalog of ideas.",
      'invisible alt text for business account creation page audienceHalfImage',
    );

    this.log = Logging.getLogger('BusinessAccountCreate');
  }

  getChildContext() {
    const { cookies, country, isMobile } = this.props;

    return {
      cookies,
      country,
      userAgent: {
        isMobile,
      },
    };
  }

  // TODO: if the user is authenticated:
  //    And a Pinner:
  //     Show a confirmation dialog to the user so that they do not accidentally convert to a business
  // TODO: flowtype
  // TODO: Unit test
  componentDidMount() {
    registerAction('loaded');
    // remarketing tags
    BusinessAcquisitionTracking.insertGoogleAdWordsTag(
      BusinessAcquisitionTrackingConstants.GOOGLE_ADWORDS_ID,
    );
    BusinessAcquisitionTracking.insertFacebookPixelTag(
      BusinessAcquisitionTrackingConstants.FACEBOOK_ADVERTISER_ID,
    );
    BusinessAcquisitionTracking.insertTwitterUniversalTag(
      BusinessAcquisitionTrackingConstants.TWITTER_UNIVERSAL_TAG_ID,
    );
    BusinessAcquisitionTracking.insertLinkedInInsightTag(
      BusinessAcquisitionTrackingConstants.LINKEDIN_PARTNER_ID,
    );
    BusinessAcquisitionTracking.insertPinterestTag(
      BusinessAcquisitionTrackingConstants.SMB_PAID_PINTEREST_ID,
    );

    /* If we don't have a view context set we add the view context manually */
    const eventLogger = contextLogger.getInstance();
    const viewFromContext = eventLogger.getViewFromContext();
    if (!viewFromContext.view_type) {
      const viewInfo = {
        view_type: PCONST.thrift.ViewType.PARTNER,
        view_parameter: PCONST.thrift.ViewParameterType.PARTNER_SIGNUP,
      };
      eventLogger.addViewToContext(viewInfo);
    }

    this.props.contextLog(PCONST.thrift.EventType.RENDER, {
      component: PCONST.thrift.ComponentType.PARTNER_SIGNUP_FORM,
      in_unified_modal: this.props.unifiedSignup,
    });

    logStats.increment('partner.business_account_create.visit', 1, { platform: 'web' });

    // mrucker: initialize these early so we don't hit a race condition with registration
    new SingleTreatmentExp(
      this.props.requestContext,
      'biz_growth_upgrade_user_registration',
    ).enabled();
  }

  getLoginUrl = () => {
    const {
      router: {
        location: { query },
      },
    } = this.props;

    if (query && 'next' in query) {
      return urlUtil.buildRelativeUrl('/login', { next: query.next });
    }
    const next = this.inAdCreditsCampaign()
      ? appendQuery('/business/create/', { utm_medium: 'adcredits' })
      : '/business/create/';
    return urlUtil.buildRelativeUrl('/login', { next });
  };

  handleFieldChange = (field, e) => {
    let fieldValue;
    if (e.nativeEvent) {
      fieldValue = e.nativeEvent.target.value;
    } else if (e.value) {
      fieldValue = e.value;
    } else {
      fieldValue = e;
    }
    this.setState({ [field]: fieldValue });

    if (this.state.clickedSubmit) {
      this.validateField(field, fieldValue);
    }
  };

  validateField = debounce((field, val) => {
    const fieldValidators = this.validators[field];
    const fieldErrors = getErrors(fieldValidators, val);
    this.setState({
      errors: {
        ...this.state.errors,
        [field]: fieldErrors,
      },
    });
  }, FIELD_VALIDATION_TIMEOUT);

  hasValidationErrors = (field) => {
    const fieldErrors = getErrors(this.validators[field], this.state[field]);
    if (fieldErrors.length > 0) {
      this.setState({
        errors: {
          ...this.state.errors,
          [field]: fieldErrors,
        },
      });
      return true;
    } else {
      return false;
    }
  };

  validateForm = () => !(this.hasValidationErrors('email') || this.hasValidationErrors('password'));

  register = (resourceOptions) => {
    const { requestContext } = this.props;

    if (new SingleTreatmentExp(requestContext, 'biz_growth_upgrade_user_registration').enabled()) {
      return UserRegistration.register(resourceOptions);
    } else {
      return UserRegistrationDeprecated.register('partner', resourceOptions, {
        retryOnError: false,
      });
    }
  };

  handleFormSubmission = (event) => {
    event.preventDefault();
    registerAction('submit_clicked');
    this.setState({ isSubmittingForm: true });

    const { email, password } = this.state;
    const {
      contextLog,
      isAuth,
      unifiedSignup,
      router: {
        location: { query },
      },
    } = this.props;
    const businessName = email.split('@')[0];
    const submittable = this.validateForm();
    this.setState({ clickedSubmit: true });

    contextLog(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.PARTNER_SIGNUP_FORM,
      element: PCONST.thrift.ElementType.PARTNER_SIGNUP_SUBMIT_BUTTON,
      successful_frontend_validation: submittable,
      in_unified_modal: unifiedSignup,
    });

    if (submittable) {
      const emailExistsResource = ResourceFactory.create('EmailExistsResource', {
        email,
      });
      emailExistsResource.callGet({ showError: false }).then(
        (resourceResponse) => {
          if (resourceResponse.resource_response.data) {
            this.setState({
              errors: {
                ...this.state.errors,
                email: [
                  i18n._(
                    "Deja vu! That email's taken.",
                    'User entered an email that is already taken',
                  ),
                ],
              },
              isSubmittingForm: false,
            });
            contextLog(PCONST.thrift.EventType.SIGNUP_FAILURE);
          } else {
            const options = toUnderscoredObject({
              businessName,
              email,
              password,
              hasAdsCredits: this.inAdCreditsCampaign(),
            });
            logBusinessEvent('client.partner.account.create_attempt', {
              source: {
                utmPartner: query.utm_partner,
                utmSource: query.utm_source,
                utmMedium: query.utm_medium,
              },
              isAuth,
              unifiedSignup,
            });
            this.register(options).then((data) => {
              registerAction('signup_success');

              logBusinessEvent('client.partner.account.create', {
                source: {
                  utmPartner: query.utm_partner,
                  utmSource: query.utm_source,
                  utmMedium: query.utm_medium,
                },
                isAuth,
                unifiedSignup,
              });
              this.log.debug('Signup success:', data);

              const redirectUrl = query && 'next' in query ? query.next : null;

              BusinessAcquisitionTracking.reportFacebookConversion(
                BusinessAcquisitionTrackingConstants.FACEBOOK_ADVERTISER_ID,
                'CompleteRegistration',
                { content_name: '/business/create' },
              );
              BusinessAcquisitionTracking.reportPinterestConversion('track', 'lead', {
                lead_type: 'Self-serve',
              });
              BusinessAcquisitionTracking.reportLinkedInConversion(
                BusinessAcquisitionTrackingConstants.LINKEDIN_PARTNER_ID,
                BusinessAcquisitionTrackingConstants.LINKEDIN_CONVERSION_ID_SUBMISSION_EVENT,
              );
              BusinessAcquisitionTracking.reportGoogleConversion(
                BusinessAcquisitionTrackingConstants.GOOGLE_ADWORDS_ID,
                BusinessAcquisitionTrackingConstants.GOOGLE_ADWORDS_LABEL_BUSINESS_CREATE,
                redirectUrl ? undefined : '/',
              );
              if (redirectUrl) {
                changeWindowLocation(decodeURIComponent(redirectUrl));
              }
            });
          }
        },
        (error) => {
          this.setState({
            errors: {
              ...this.state.errors,
              email: [i18n._('Add a valid email', 'Prompt user to input a valid email')],
            },
            isSubmittingForm: false,
          });
        },
      );
    } else {
      this.setState({ isSubmittingForm: false });
    }
  };

  inAdCreditsCampaign = () => {
    const { router } = this.props;
    return inAdCreditsCampaign(router);
  };

  showAdditionalAdCreditsContent = () =>
    this.inAdCreditsCampaign() &&
    !new SingleTreatmentExp(
      this.props.requestContext,
      'smb_web_paid_ad_credits_simplify',
    ).enabled();

  toggleLoadingIndicator = (on) => {
    this.setState({ isSubmittingForm: on });
  };

  onFBEmailDeniedPerm = () => {
    showError(i18n.commonStrings.connectError);
    this.toggleLoadingIndicator(false);
    this.setState({ isRerequest: true });
  };

  renderForm() {
    const { email, errors, password, isSubmittingForm } = this.state;
    const { unifiedSignup } = this.props;
    const inAdCreditsCampaign = this.inAdCreditsCampaign();
    return (
      <form method="POST" noValidate onSubmit={this.handleFormSubmission}>
        <Box>
          <Box
            paddingY={1}
            position="relative"
            dangerouslySetInlineStyle={{ __style: { zIndex: 3 } }}
          >
            <TextInputField
              id="email"
              name="email"
              type="email"
              onChange={(e) => {
                this.handleFieldChange('email', e);
              }}
              onFocus={() => registerFocus('email')}
              value={email}
              placeholder={i18n._('Email', 'Placeholder text for email field')}
              useExperimentalTextfield={unifiedSignup}
              useGestalt
              tooltip={errors.email.length > 0 ? errors.email[0] : null}
              hasError={errors.email.length > 0}
            />
          </Box>
          <Box
            paddingY={1}
            position="relative"
            dangerouslySetInlineStyle={{ __style: { zIndex: 2 } }}
          >
            <TextInputField
              id="password"
              name="password"
              type="password"
              onChange={(e) => {
                this.handleFieldChange('password', e);
              }}
              onFocus={() => registerFocus('password')}
              value={password}
              placeholder={
                unifiedSignup
                  ? i18n._('Create a password', 'Placeholder text for password field')
                  : i18n._('Password', 'Placeholder text for password field')
              }
              useExperimentalTextfield={unifiedSignup}
              useGestalt
              tooltip={errors.password.length > 0 ? errors.password[0] : null}
              hasError={errors.password.length > 0}
            />
          </Box>
          <Box paddingY={1}>
            <Button
              color="red"
              disabled={isSubmittingForm}
              onClick={this.handleFormSubmission}
              type="submit"
              text={i18n._('Create account', 'Button text for creating a business account')}
              size="md"
            />
          </Box>
          <Box paddingY={1}>
            <Button
              size="md"
              onClick={() => changeWindowLocation(this.getLoginUrl())}
              text={i18n._('Log in')}
            />
          </Box>
          <Experiment name="smb_web_facebook_signup_button_unauth">
            {({ anyEnabled: inFbSignupExp }) =>
              inFbSignupExp && (
                <Box>
                  <Box marginBottom={2}>
                    <AlternativesSeparator />
                    <Box marginTop={3}>
                      <FacebookConnectButton
                        buttonText={i18n._(
                          'Login with Facebook',
                          'Button text on facebook connect button',
                        )}
                        loadingIndicatorCallback={this.toggleLoadingIndicator}
                        isBusiness
                        disablePostSignupNextUrl
                        nextUrlParam="/business/convert"
                        isRerequest={this.state.isRerequest}
                        onFBEmailDeniedPerm={this.onFBEmailDeniedPerm}
                      />
                    </Box>
                  </Box>
                </Box>
              )
            }
          </Experiment>
          <Box paddingY={1}>
            <Text size="xs" align={inAdCreditsCampaign ? 'left' : 'center'} overflow="normal">
              {interpolateNamedTemplate(
                i18n._(
                  'Creating an account means you’re okay with Pinterest’s {{ termsLink }} and {{ privacyLink }}.',
                  'Notice that proceeding indicates acceptance of term and policy',
                ),
                {
                  termsLink: (
                    <Link href={termsOfServiceUrl} target="blank" key={0} inline>
                      {i18n._('Business Terms of Service', 'Link to Terms of Service')}
                    </Link>
                  ),
                  privacyLink: (
                    <Link href={privacyUrl} target="blank" key={1} inline>
                      {i18n._('Privacy Policy', 'Link to Pinterest Privacy Policy')}
                    </Link>
                  ),
                },
              )}
            </Text>
            {this.inAdCreditsCampaign() && (
              <Text size="xs" align="left" overflow="normal">
                {this.showAdditionalAdCreditsContent()
                  ? adCreditsDisclaimerText
                  : adCreditsDisclaimerTextSimplified}
              </Text>
            )}
          </Box>
        </Box>
      </form>
    );
  }

  renderRightHalf() {
    return (
      <Box
        display="flex"
        alignItems={this.inAdCreditsCampaign() ? 'start' : 'center'}
        minHeight={500}
        color="white"
        position="relative"
      >
        {this.renderLoadingMask()}
        <Box paddingX={10} color="white" paddingY={8}>
          <Box justifyContent="center" alignItems="center" marginBottom={5} display="flex">
            <Icon accessibilityLabel="Pinterest Logo" color="red" icon="pinterest" size={40} />
          </Box>
          <Box marginBottom={2} data-test-id="businessAccountCreateTitle">
            <Text align="center">
              <Heading size="xs">
                {i18n._('Grow your business', 'Desktop business signup heading')}
              </Heading>
            </Text>
          </Box>
          <Box marginBottom={3}>
            <Text align="center" size="sm">
              {!this.inAdCreditsCampaign()
                ? i18n._(
                    'Get in front of 250 million people looking to buy, make, and do.',
                    'Desktop business signup subheading',
                  )
                : i18n._(
                    'Reach more of the 250 million people looking for inspiration on Pinterest each month',
                    'Desktop business signup subheading for ad credits',
                  )}
            </Text>
          </Box>
          {this.renderForm()}
        </Box>
      </Box>
    );
  }

  renderPage(businessImages) {
    const halfImgSrc = businessImages.halfImage;
    const showAdditionalAdCreditsContent = this.showAdditionalAdCreditsContent();
    return (
      <Box data-test-id="businessAccountCreateContainer" width="100%">
        <Container>
          <Box marginLeft={2} marginRight={2}>
            <Mask shape="rounded">
              <Column xs={0} md={6}>
                <Box
                  position="absolute"
                  top
                  left
                  bottom
                  width="50%"
                  xs={{ display: false }}
                  md={{ display: 'inlineBlock' }}
                  color={showAdditionalAdCreditsContent ? 'lightGray' : null}
                >
                  {showAdditionalAdCreditsContent ? (
                    <Box paddingY={7} paddingX={7} width={350}>
                      <Heading size="md" color="darkGray">
                        Try Pinterest ads with <br />a $20 credit*
                      </Heading>
                      <Box marginTop={3}>
                        <Text bold size="lg" color="darkGray" overflow="normal">
                          Get $20 back when you spend
                          <br />
                          $30 on ads
                        </Text>
                      </Box>
                    </Box>
                  ) : (
                    <Image
                      alt={this.title}
                      src={halfImgSrc}
                      naturalHeight={546}
                      naturalWidth={404}
                      fit="cover"
                    />
                  )}
                </Box>
              </Column>
              <Column xs={12} md={6}>
                {this.renderRightHalf()}
              </Column>
            </Mask>
          </Box>
        </Container>
      </Box>
    );
  }

  renderWithoutImage() {
    return (
      <Box data-test-id="businessAccountCreateContainer" width="100%">
        <Container>
          <Column xs={0} md={3} />
          <Column xs={12} md={6}>
            <Mask shape="rounded">{this.renderRightHalf()}</Mask>
          </Column>
          <Column xs={0} md={3} />
        </Container>
      </Box>
    );
  }

  renderLoadingMask() {
    const { isSubmittingForm } = this.state;

    return isSubmittingForm ? <LoadingMask /> : null;
  }

  render() {
    const { isMobile, unifiedSignup } = this.props;
    const { businessImages, showWarningModal } = this.state;
    const backgroundImgSrc = businessImages.background;
    if (showWarningModal) {
      return (
        <Box>
          <Box position="fixed" top left bottom right>
            <Image
              alt={this.title}
              color="white"
              naturalHeight={763}
              naturalWidth={1354}
              src={backgroundImgSrc}
              fit="cover"
            />
          </Box>
          <Box>
            <BusinessAccountCreateWarningModal />
          </Box>
        </Box>
      );
    } else if (isMobile) {
      return <Box>{this.renderPage(businessImages)}</Box>;
    } else if (unifiedSignup) {
      return (
        <Box display="flex" alignItems="center" justifyContent="center">
          {this.renderLoadingMask()}
          <Box width={268} color="white">
            {this.renderForm()}
          </Box>
        </Box>
      );
    } else {
      const shouldHideImage = new SingleTreatmentExp(
        this.props.requestContext,
        'smb_web_business_create_form_only',
      ).enabled();
      return (
        <Box>
          <Box position="fixed" top left bottom right>
            <Image
              alt={this.title}
              color="white"
              naturalHeight={763}
              naturalWidth={1354}
              src={backgroundImgSrc}
              fit="cover"
            />
          </Box>
          <Box
            position="absolute"
            top
            left
            bottom
            right
            display="flex"
            justifyContent="center"
            alignItems="center"
            overflow="scroll"
            minHeight={600}
          >
            {shouldHideImage ? this.renderWithoutImage() : this.renderPage(businessImages)}
          </Box>
        </Box>
      );
    }
  }
}

export default compose(
  withUnauthSeoExperiments,
  withContextLog,
  withRequestContext,
  withRouter,
)(BusinessAccountCreate);
